import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select, { OnChangeType, OptionType } from 'src/components/Select';
import TextField from 'src/components/TextField';
import { UserType } from 'src/types/user';

export interface DetailPropsType {
    data: UserType;
    permissionUpdate: boolean;
    rolesOptions: OptionType[];
    selectedRoles: number[];
    onChangeRoles: OnChangeType;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={6}>
                <TextField
                    value={props.data.NAME}
                    name="NAME"
                    label={translate('userPermissionsDetail.name')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.data.SURNAME}
                    name="SURNAME"
                    label={translate('userPermissionsDetail.surname')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.rolesOptions}
                    value={props.selectedRoles}
                    onChange={props.onChangeRoles}
                    name="roles"
                    label={translate('userPermissionsDetail.roles')}
                    fullWidth
                    multiple
                    limitTags={4}
                    disabled={!props.permissionUpdate}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
